export type PaymentItemType = keyof typeof PaymentItemType;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentItemType = {
  AVAILABLE_FEATURE: 'AVAILABLE_FEATURE',
  FEATURE_USAGE: 'FEATURE_USAGE',
  PLAN: 'PLAN',
  PLUGIN: 'PLUGIN',
} as const;
